import moment from 'moment';
import { api } from '$app/api';

const TODAY = moment().format('YYYY-MM-DD');
const LIMIT = 31 * 3; // 3 months (ish)

export function getCapacities(segment) {
  return api.get(`/capacity/${segment}?today=${TODAY}&limit=${LIMIT}`).then((res) => res.data);
}

export function updateCapacity(segment, capacity, day) {
  return api
    .put(`/capacity/${segment}/${day}`, {
      capacity,
    })
    .then((res) => res.data);
}
